
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9nY0o", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $c6GJD = parcelRequire("c6GJD");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $03440d6b72110eb9$export$e8ff3768de40dcb2 = ()=>(parcelRequire("bwF9G"));



var $bkHj8 = parcelRequire("bkHj8");


var $1CBzK = parcelRequire("1CBzK");


var $aNNfK = parcelRequire("aNNfK");

const $97dae280575301ff$var$PRELOADER_SMART_CARD = 'smart-card';
const $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $97dae280575301ff$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $97dae280575301ff$var$ALL_PRELOADERS = [
    $97dae280575301ff$var$PRELOADER_SMART_CARD,
    $97dae280575301ff$var$PRELOADER_AUTO_SUGGEST,
    $97dae280575301ff$var$PRELOADER_SMART_CREATION,
    $97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG
];
let $97dae280575301ff$var$hasPreloadedChatOnIntent = false;
function $97dae280575301ff$var$isPreloaderName(preloader) {
    return $97dae280575301ff$var$ALL_PRELOADERS.includes(preloader);
}
function $97dae280575301ff$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($97dae280575301ff$var$isPreloaderName));
}
function $97dae280575301ff$var$preloadSmartCard() {
    (0, $03440d6b72110eb9$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $97dae280575301ff$var$preloadAutoSuggest() {
    (0, $bkHj8.importAutoSuggest)().catch(()=>{});
}
function $97dae280575301ff$var$preloadSmartCreationWrapper() {
    (0, $aNNfK.importSmartCreationWrapper)().catch(()=>{});
}
function $97dae280575301ff$var$preloadFeedbackFlag() {
    (0, $1CBzK.importFeedbackFlag)().catch(()=>{});
}
function $97dae280575301ff$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($97dae280575301ff$var$hasPreloadedChatOnIntent) return;
    $97dae280575301ff$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $97dae280575301ff$var$getEnabledPreloaders((0, $c6GJD.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CARD)) $97dae280575301ff$var$preloadSmartCard();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_AUTO_SUGGEST)) $97dae280575301ff$var$preloadAutoSuggest();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_SMART_CREATION)) $97dae280575301ff$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($97dae280575301ff$var$PRELOADER_FEEDBACK_FLAG)) $97dae280575301ff$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $97dae280575301ff$export$778f6ecee92cc30c;

});

parcelRegister("bwF9G", function(module, exports) {

let $86429b6a007ea2e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $86429b6a007ea2e9$var$load("drBZv"),
    $86429b6a007ea2e9$var$load("hms4a"),
    $86429b6a007ea2e9$var$load("cvaU1"),
    $86429b6a007ea2e9$var$load("fq4gq"),
    $86429b6a007ea2e9$var$load("3q2Ng"),
    $86429b6a007ea2e9$var$load("jRpDi"),
    $86429b6a007ea2e9$var$load("iXxzp"),
    $86429b6a007ea2e9$var$load("dYtBN"),
    $86429b6a007ea2e9$var$load("kNV5Y"),
    $86429b6a007ea2e9$var$load("ieWJf"),
    $86429b6a007ea2e9$var$load("cnNpB"),
    $86429b6a007ea2e9$var$load("27glK"),
    $86429b6a007ea2e9$var$load("bvY53"),
    $86429b6a007ea2e9$var$load("f6ci5"),
    $86429b6a007ea2e9$var$load("7jSfd"),
    $86429b6a007ea2e9$var$load("4HZlX"),
    $86429b6a007ea2e9$var$load("kDqHr"),
    $86429b6a007ea2e9$var$load("gT8XU"),
    $86429b6a007ea2e9$var$load("3GuOt"),
    $86429b6a007ea2e9$var$load("3Mspc"),
    $86429b6a007ea2e9$var$load("9aQIt"),
    $86429b6a007ea2e9$var$load("XZauT"),
    $86429b6a007ea2e9$var$load("4S1SF"),
    $86429b6a007ea2e9$var$load("lm9Lt"),
    $86429b6a007ea2e9$var$load("9wPDc"),
    $86429b6a007ea2e9$var$load("1MWOL"),
    $86429b6a007ea2e9$var$load("6fQco"),
    $86429b6a007ea2e9$var$load("aOY32"),
    $86429b6a007ea2e9$var$load("3MYQs"),
    $86429b6a007ea2e9$var$load("6SWFK"),
    $86429b6a007ea2e9$var$load("5zapo"),
    $86429b6a007ea2e9$var$load("jiFtb"),
    $86429b6a007ea2e9$var$load("6wr18"),
    $86429b6a007ea2e9$var$load("9atVd"),
    $86429b6a007ea2e9$var$load("dek7I"),
    $86429b6a007ea2e9$var$load("6iz6l"),
    $86429b6a007ea2e9$var$load("4SCW2"),
    $86429b6a007ea2e9$var$load("ffEVr"),
    $86429b6a007ea2e9$var$load("hhss7"),
    $86429b6a007ea2e9$var$load("kuFG2"),
    $86429b6a007ea2e9$var$load("Wowvf"),
    $86429b6a007ea2e9$var$load("i4cia")
]).then(()=>parcelRequire('bAzak'));

});

parcelRegister("bkHj8", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $a271a3136aaf0862$export$5531859f311f2932() {
    return (parcelRequire("kxRBa"));
}
module.exports["importAutoSuggest"] = $a271a3136aaf0862$export$5531859f311f2932;

});

parcelRegister("kxRBa", function(module, exports) {

let $ef507743c7ac0566$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef507743c7ac0566$var$load("drBZv"),
    $ef507743c7ac0566$var$load("hms4a"),
    $ef507743c7ac0566$var$load("cvaU1"),
    $ef507743c7ac0566$var$load("fq4gq"),
    $ef507743c7ac0566$var$load("6wr18"),
    $ef507743c7ac0566$var$load("2tIxk"),
    $ef507743c7ac0566$var$load("dLq4a"),
    $ef507743c7ac0566$var$load("27glK"),
    $ef507743c7ac0566$var$load("bvY53"),
    $ef507743c7ac0566$var$load("ffEVr"),
    $ef507743c7ac0566$var$load("219St"),
    $ef507743c7ac0566$var$load("b1DMS"),
    $ef507743c7ac0566$var$load("kuFG2"),
    $ef507743c7ac0566$var$load("397zr")
]).then(()=>parcelRequire('8AQV8'));

});

parcelRegister("1CBzK", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $af524f9041864d2f$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("hEkII"));
module.exports["importFeedbackFlag"] = $af524f9041864d2f$export$1eafe3a5df99a0a0;

});

parcelRegister("hEkII", function(module, exports) {

let $cd963eae86499499$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd963eae86499499$var$load("2xz6W").then(()=>parcelRequire('gHwil'));

});

parcelRegister("aNNfK", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $85c671e208740b9c$export$f67978e62543a686 = ()=>(parcelRequire("dG8GI"));
module.exports["importSmartCreationWrapper"] = $85c671e208740b9c$export$f67978e62543a686;

});

parcelRegister("dG8GI", function(module, exports) {

let $9f55efd53f28b09f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9f55efd53f28b09f$var$load("aYuKh"),
    $9f55efd53f28b09f$var$load("c0JsV"),
    $9f55efd53f28b09f$var$load("h3ABO"),
    $9f55efd53f28b09f$var$load("5o4Kn"),
    $9f55efd53f28b09f$var$load("6rS39"),
    $9f55efd53f28b09f$var$load("kbwlB"),
    $9f55efd53f28b09f$var$load("drBZv"),
    $9f55efd53f28b09f$var$load("hms4a"),
    $9f55efd53f28b09f$var$load("h78l8"),
    $9f55efd53f28b09f$var$load("2YffH"),
    $9f55efd53f28b09f$var$load("eu773"),
    $9f55efd53f28b09f$var$load("kOhn4"),
    $9f55efd53f28b09f$var$load("9XOeB"),
    $9f55efd53f28b09f$var$load("xu7ej"),
    $9f55efd53f28b09f$var$load("iQ4FP"),
    $9f55efd53f28b09f$var$load("71gca"),
    $9f55efd53f28b09f$var$load("hCEec"),
    $9f55efd53f28b09f$var$load("k3Yy8"),
    $9f55efd53f28b09f$var$load("8HNwV"),
    $9f55efd53f28b09f$var$load("im1VN"),
    $9f55efd53f28b09f$var$load("lG1w2"),
    $9f55efd53f28b09f$var$load("9anPW"),
    $9f55efd53f28b09f$var$load("gWJnq"),
    $9f55efd53f28b09f$var$load("586p9"),
    $9f55efd53f28b09f$var$load("aV2lJ"),
    $9f55efd53f28b09f$var$load("aapZc"),
    $9f55efd53f28b09f$var$load("gnDXu"),
    $9f55efd53f28b09f$var$load("3q2Ng"),
    $9f55efd53f28b09f$var$load("jRpDi"),
    $9f55efd53f28b09f$var$load("ieWJf"),
    $9f55efd53f28b09f$var$load("cnNpB"),
    $9f55efd53f28b09f$var$load("f6ci5"),
    $9f55efd53f28b09f$var$load("lTK3c"),
    $9f55efd53f28b09f$var$load("1WXdc"),
    $9f55efd53f28b09f$var$load("iB5Rm"),
    $9f55efd53f28b09f$var$load("jx1f9"),
    $9f55efd53f28b09f$var$load("b2FtX"),
    $9f55efd53f28b09f$var$load("58VDA"),
    $9f55efd53f28b09f$var$load("fZsRh"),
    $9f55efd53f28b09f$var$load("6iz6l"),
    $9f55efd53f28b09f$var$load("4SCW2"),
    $9f55efd53f28b09f$var$load("bmmTH"),
    $9f55efd53f28b09f$var$load("lVrrs"),
    $9f55efd53f28b09f$var$load("3NkiL"),
    $9f55efd53f28b09f$var$load("cvaU1"),
    $9f55efd53f28b09f$var$load("6wr18"),
    $9f55efd53f28b09f$var$load("2tIxk"),
    $9f55efd53f28b09f$var$load("dLq4a"),
    $9f55efd53f28b09f$var$load("27glK"),
    $9f55efd53f28b09f$var$load("bvY53"),
    $9f55efd53f28b09f$var$load("DhQ4t"),
    $9f55efd53f28b09f$var$load("2jmmL"),
    $9f55efd53f28b09f$var$load("hhss7"),
    $9f55efd53f28b09f$var$load("Wowvf"),
    $9f55efd53f28b09f$var$load("ffEVr"),
    $9f55efd53f28b09f$var$load("219St"),
    $9f55efd53f28b09f$var$load("b1DMS"),
    $9f55efd53f28b09f$var$load("jnVKv"),
    $9f55efd53f28b09f$var$load("fq4gq"),
    $9f55efd53f28b09f$var$load("7EorR"),
    $9f55efd53f28b09f$var$load("bgHzk"),
    $9f55efd53f28b09f$var$load("cU3hB")
]).then(()=>parcelRequire('k9rA8'));

});


//# sourceMappingURL=preload-chat-on-intent.0e772ccc.js.map
